import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
    Grid,
    Paper,
    Tabs,
    Tab,
    Button,
    withWidth,
    makeStyles,
    Title,
    Typography,
    Divider,
    ButtonGroup,
    Chip,
    Box,
} from "@material-ui/core";

import { AuthContext } from "../../context/Auth/AuthContext";
import whatsBackground from "../../assets/wa-background.png";
import { ChatModal } from "../../components/ChatModal";
import ChatList from "../../components/ChatList";
import ChatMessages from "../../components/ChatMessages";
import { isWidthUp } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { isObject, has } from "lodash";
import { BorderRight } from "@material-ui/icons";
import { set } from "date-fns";
import openSocket from "../../services/socket-io";
import { padding } from "@mui/system";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { ReactComponent as ArrowLeft } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        flex: 1,
        padding: theme.spacing(2),
        height: `calc(100% - 48px)`,
        overflowY: "hidden",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        backgroundImage: `url(${whatsBackground})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        [theme.breakpoints.down("sm")]: {
            backgroundColor: "#fff",
            padding: 0,
          },
    },
    gridContainer: {
        flex: 1,
        height: "100%",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        backgroundColor: "inherit",
        overflow: "hidden",
    },
    gridItem: {
        height: "100%",
        overflow: "hidden",
    },
    gridItemTab: {
        height: "92%",
        width: "100%",
    },
    btnContainer: {
        textAlign: "right",
        padding: 10,
        [theme.breakpoints.down(1400)]: {
            textAlign: "left",
        }
    },
    drawerPaper: {
        backgroundColor: "#ededed",
        //backgroundColor: "#151d86",
        position: "relative",
        //whiteSpace: "nowrap",
        height: "100%",
    },
    titleContainer: {
        textAlign: "left",
        padding: 10,
        marginLeft: 16,
        textTransform: "uppercase",
    },
    container: {
        display: "flex",
        itemAlign: "center",
        [theme.breakpoints.down(1400)]: {
            flexDirection: "column",
        }
    },
    topBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 16px",
        gap: 8,
    },
    filterContainer: {
        padding: "10px 16px",
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    filterChip: {
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
            transform: "scale(1.05)",
        }
    },
}));

function InternalChat(props) {
    const classes = useStyles();
    const { user } = useContext(AuthContext);
    const history = useHistory();

    const [showDialog, setShowDialog] = useState(false);
    const [dialogType, setDialogType] = useState("new");
    const [currentChat, setCurrentChat] = useState({});
    const [chats, setChats] = useState([]);
    const [allChats, setAllChats] = useState([]); // Store all chats
    const [chatFilter, setChatFilter] = useState("all"); // Filter: all, myChats, involved
    const [chatsPageInfo, setChatsPageInfo] = useState({ hasMore: false });
    const [messages, setMessages] = useState([]);
    const [messagesPageInfo, setMessagesPageInfo] = useState({ hasMore: false });
    const [messagesPage, setMessagesPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tab, setTab] = useState(0);
    const isMounted = useRef(true);
    const scrollToBottomRef = useRef();
    //const { id } = useParams();


    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (isMounted.current) {
            findChats().then((data) => {

                if (data.length > 0) {
                    setAllChats(data);
                    setChats(data);
                    setTab(1);
                    setChatsPageInfo({ hasMore: true });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Apply filter when chatFilter or allChats change
    useEffect(() => {
        applyFilter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chatFilter, allChats]);

    useEffect(() => {
        if (isObject(currentChat) && has(currentChat, "id")) {
            findMessages(currentChat.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentChat]);

    useEffect(() => {

        const socket = openSocket();

        socket.on("chat", (data) => {
            if (data.action === "create") {
                setAllChats((prev) => [data.chat, ...prev]);
            }

            if (data.action === "delete") {
                setAllChats((prev) => prev.filter((chat) => chat.id !== data.chat.id));
                setCurrentChat({});
                setMessages([]);
                setMessagesPage(1);
                setMessagesPageInfo({ hasMore: false });
                history.push("/chats");
            }

            if (data.action === "update") {
                setAllChats((prev) => {
                    return prev.map((chat) => {
                        if (chat.id === data.chat.id) {
                            // Atualiza o chat com as novas informações
                            return { ...data.chat };
                        }
                        // Mantém os outros chats inalterados
                        return chat;
                    });
                });
                setCurrentChat(data.chat);
                history.push("/chats");
            };
        });

        socket.on("chatMessage", (data) => {
            if (data.action === "create") {
                if (data.chat.id === currentChat.id) {
                    // Remove mensagem temporária se existir e adiciona a mensagem real
                    setMessages((prev) => {
                        const filtered = prev.filter(msg => !msg.isTemp);
                        return [...filtered, data.newMessage];
                    });
                    
                    // Fazer scroll apenas se for mensagem do próprio usuário
                    if (data.newMessage.userId === user.id) {
                        if (typeof scrollToBottomRef.current === "function") {
                            setTimeout(() => {
                                scrollToBottomRef.current(true);
                            }, 50);
                        }
                    } else {
                        // Se for de outro usuário, só rola se estiver perto do final
                        if (typeof scrollToBottomRef.current === "function") {
                            setTimeout(() => {
                                scrollToBottomRef.current(false);
                            }, 50);
                        }
                    }
                }
                
                // Atualizar lista de chats
                const changedChats = allChats.map((chat) => {
                    if (chat.id === data.newMessage.chatId) {
                        if (data.chat.id === currentChat.id) {
                            setCurrentChat(data.chat);
                        }
                        return {
                            ...data.chat,
                        };
                    }
                    return chat;
                });
                setAllChats(changedChats);
            }

            if (data.action === "update") {
                if (data.chat.id === currentChat.id) {
                    const changedChats = allChats.map((chat) => {
                        if (chat.id === data.chat.id) {
                            setCurrentChat(data.chat);
                            return {
                                ...data.chat,
                            };
                        }
                        return chat;
                    });
                    setAllChats(changedChats);
                }
            }
        });

        return () => {
            socket.disconnect();
        }

    }, [allChats, currentChat.id, history]);


    const selectChat = (chat) => {
        try {
            setMessages([]);
            setMessagesPage(1);
            setCurrentChat(chat);
            setTab(1);
            history.push("/chats");
        } catch (err) { }
    };

    const handleSendMessage = (tempMessage) => {
        // Adicionar mensagem temporária ao estado
        setMessages((prev) => [...prev, tempMessage]);
        
        // Forçar scroll ao enviar mensagem própria
        if (typeof scrollToBottomRef.current === "function") {
            setTimeout(() => {
                scrollToBottomRef.current(true);
            }, 50);
        }
    };

    const handleChatRead = (chatId, userId) => {
        // Atualizar o chat localmente para remover badge imediatamente
        setAllChats((prev) => {
            return prev.map((chat) => {
                if (chat.id === chatId && chat.users) {
                    const updatedUsers = chat.users.map((chatUser) => {
                        if (chatUser.userId === userId || chatUser.ownerId === userId) {
                            return { ...chatUser, unreads: 0 };
                        }
                        return chatUser;
                    });
                    return { ...chat, users: updatedUsers };
                }
                return chat;
            });
        });
    };

    const deleteChat = async (chat) => {
        try {
            await api.delete(`/chats/${chat.id}`);
        } catch (err) {
            toastError(err);
        }
    };

    const findMessages = async (chatId) => {
        setLoading(true);
        try {
            const { data } = await api.get(
                `/chats/${chatId}/messages?pageNumber=${messagesPage}`
            );
            setMessagesPage((prev) => prev + 1);
            setMessagesPageInfo(data);
            setMessages((prev) => [...data.messages, ...prev]);
        } catch (err) { }
        setLoading(false);
    };

    const loadMoreMessages = async () => {
        if (!loading) {
            findMessages(currentChat.id);
        }
    };

    const applyFilter = () => {
        if (chatFilter === "all") {
            setChats(allChats);
        } else if (chatFilter === "myChats") {
            // Filter chats created by current user
            const filtered = allChats.filter(chat => chat.ownerId === user.id);
            setChats(filtered);
        } else if (chatFilter === "involved") {
            // Filter chats where user is involved (owner or participant)
            const filtered = allChats.filter(chat => {
                if (chat.ownerId === user.id) return true;
                if (chat.users && chat.users.length > 0) {
                    return chat.users.some(u => u.userId === user.id || u.ownerId === user.id);
                }
                return false;
            });
            setChats(filtered);
        }
    };

    const handleFilterChange = (filter) => {
        setChatFilter(filter);
    };

    const getFilterCount = (filter) => {
        if (filter === "all") {
            return allChats.length;
        } else if (filter === "myChats") {
            return allChats.filter(chat => chat.ownerId === user.id).length;
        } else if (filter === "involved") {
            return allChats.filter(chat => {
                if (chat.ownerId === user.id) return true;
                if (chat.users && chat.users.length > 0) {
                    return chat.users.some(u => u.userId === user.id || u.ownerId === user.id);
                }
                return false;
            }).length;
        }
        return 0;
    };

    const findChats = async () => {
        try {
            const { data } = await api.get("/chats");
            return data;
        } catch (err) {
            console.log(err);
        }
    };

    const renderGrid = () => {
        return (
            <>
                <Grid className={classes.gridContainer} container>
                    <Grid className={classes.drawerPaper} md={3} item>
                        <div className={classes.titleContainer}>
                            <Typography variant="h6" color="primary">Chat Interno</Typography>
                        </div>
                        <Box className={classes.topBar}>
                            <Button
                                onClick={() => {
                                    setDialogType("new");
                                    setShowDialog(true);
                                }}
                                color="primary"
                                variant="contained"
                                size="small"
                            >
                                Nova
                            </Button>
                            <Chip
                                label={`Todos (${getFilterCount("all")})`}
                                className={classes.filterChip}
                                color={chatFilter === "all" ? "primary" : "default"}
                                onClick={() => handleFilterChange("all")}
                                size="small"
                            />
                        </Box>
                        <Box className={classes.filterContainer}>
                            <Chip
                                label={`Meus Chats (${getFilterCount("myChats")})`}
                                className={classes.filterChip}
                                color={chatFilter === "myChats" ? "primary" : "default"}
                                onClick={() => handleFilterChange("myChats")}
                                size="small"
                            />
                            <Chip
                                label={`Envolvido (${getFilterCount("involved")})`}
                                className={classes.filterChip}
                                color={chatFilter === "involved" ? "primary" : "default"}
                                onClick={() => handleFilterChange("involved")}
                                size="small"
                            />
                        </Box>
                        <ChatList
                            chats={chats}
                            pageInfo={chatsPageInfo}
                            loading={loading}
                            handleSelectChat={(chat) => selectChat(chat)}
                            handleDeleteChat={(chat) => deleteChat(chat)}
                            handleEditChat={() => {
                                setDialogType("edit");
                                setShowDialog(true);
                            }}
                            onChatRead={handleChatRead}
                        />
                    </Grid>
                    <Divider></Divider>
                    <Grid className={classes.gridItem} md={9} item>
                        {isObject(currentChat) && has(currentChat, "id") && (
                            <ChatMessages
                                chat={currentChat}
                                scrollToBottomRef={scrollToBottomRef}
                                pageInfo={messagesPageInfo}
                                messages={messages}
                                loading={loading}
                                handleLoadMore={loadMoreMessages}
                                onSendMessage={handleSendMessage}
                            />
                        )}
                    </Grid>
                </Grid>
            </>
        );
    };

    const renderTab = () => {
        return (
            <Grid className={classes.gridContainer} container>
                <Grid md={12} item>
                    <Tabs
                        value={tab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, v) => setTab(v)}
                        aria-label="disabled tabs example"
                    >
                        <Tab label="Chats" />
                        <Tab label="Mensagens" />
                    </Tabs>
                </Grid>
                {tab === 0 && (
                    <Grid className={classes.gridItemTab} md={12} item>
                        <div className={classes.btnContainer}>
                            <Button
                                onClick={() => setShowDialog(true)}
                                color="primary"
                                variant="contained"
                            >
                                Novo
                            </Button>
                        </div>
                        <Box className={classes.filterContainer}>
                            <Chip
                                label={`Todos (${getFilterCount("all")})`}
                                className={classes.filterChip}
                                color={chatFilter === "all" ? "primary" : "default"}
                                onClick={() => handleFilterChange("all")}
                                size="small"
                            />
                            <Chip
                                label={`Meus (${getFilterCount("myChats")})`}
                                className={classes.filterChip}
                                color={chatFilter === "myChats" ? "primary" : "default"}
                                onClick={() => handleFilterChange("myChats")}
                                size="small"
                            />
                            <Chip
                                label={`Envolvido (${getFilterCount("involved")})`}
                                className={classes.filterChip}
                                color={chatFilter === "involved" ? "primary" : "default"}
                                onClick={() => handleFilterChange("involved")}
                                size="small"
                            />
                        </Box>
                        <ChatList
                            chats={chats}
                            pageInfo={chatsPageInfo}
                            loading={loading}
                            handleSelectChat={(chat) => selectChat(chat)}
                            handleDeleteChat={(chat) => deleteChat(chat)}
                            onChatRead={handleChatRead}
                        />
                    </Grid>
                )}
                {tab === 1 && (
                    <Grid className={classes.gridItemTab} md={12} item>
                        {isObject(currentChat) && has(currentChat, "id") && (
                            <ChatMessages
                                chat={currentChat}
                                scrollToBottomRef={scrollToBottomRef}
                                pageInfo={messagesPageInfo}
                                messages={messages}
                                loading={loading}
                                handleLoadMore={loadMoreMessages}
                                onSendMessage={handleSendMessage}
                            />
                        )}
                    </Grid>
                )}
            </Grid>
        );
    };

    return (
        <>
            <ChatModal
                type={dialogType}
                open={showDialog}
                chat={currentChat}
                handleLoadNewChat={(data) => {
                    // Adicionar o novo chat no topo da lista
                    setAllChats((prev) => {
                        // Verificar se o chat já não existe na lista
                        const exists = prev.some(chat => chat.id === data.id);
                        if (exists) {
                            return prev;
                        }
                        return [data, ...prev];
                    });
                    setMessages([]);
                    setMessagesPage(1);
                    setCurrentChat(data);
                    setTab(1);
                    //history.push(`/chats/${data.uuid}`);
                }}
                handleClose={() => setShowDialog(false)}
            />
            <Paper className={classes.mainContainer}>
                {isWidthUp("md", props.width) ? renderGrid() : renderTab()}
            </Paper>
        </>
    );
}

export default withWidth()(InternalChat);